// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_Cw8Mq {
  width: 50%;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/views/maintenance/MaintenanceReminders.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;AACZ","sourcesContent":[".container {\n  width: 50%;\n  margin: 0 auto;\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_Cw8Mq`
};
export default ___CSS_LOADER_EXPORT___;
